import storage from 'good-storage'
import {getDataType} from './utils'

class UrlHistory {
  constructor () {
    this.cache = storage.session
    this.key = 'url_history'
  }

  get () {
    return this.cache.get(this.key, [])
  }

  set (value) {
    let list = this.get()
    if (getDataType(value) === 'Array') {
      list = list.concat(value)
    } else if (getDataType(value) === 'String') {
      const index = list.findIndex(r => r === value)
      if (index < 0) {
        list.push(value)
      } else {
        list.splice(index + 1)
      }
    }
    this.cache.set(this.key, list)
  }
}

export default new UrlHistory()



// WEBPACK FOOTER //
// ./src/lib/urlHistory.js